import { gql } from '@apollo/client';

export const UPDATE_CURRENT_USER = gql`
  mutation UpdateCurrentPortalUser(
    $firstName: String
    $lastName: String
    $password: String
    $passwordConfirmation: String
  ) {
    updateCurrentPortalUser(
      firstName: $firstName
      lastName: $lastName
      password: $password
      passwordConfirmation: $passwordConfirmation
    ) {
      portalUser {
        id
      }
    }
  }
`;
